<template>
    <div class="dropdownMenu">
        <div
            v-for="group in itemGroups"
            v-bind:key="group.key"
            class="dropdownGroup"
        >
            <div class="dropdownGroup_title">
                {{ group.title }}
            </div>
            <div
                v-for="item in group.items"
                v-bind:key="item.key"
                v-gtm:page="item.gtm.page"
                v-gtm:type="item.gtm.type"
                v-gtm:label="item.gtm.label"
                v-gtm:identity="item.gtm.identity"
                v-gtm:license="item.gtm.license"
                v-gtm:currency="item.gtm.currency"
                v-gtm:uuid="item.gtm.uuid"
                v-gtm:@click
                class="dropdownItem"
                v-bind:class="{ active: item.isActive, disabled: group.isDisabled }"
                v-on:click="item.onClick"
            >
                <SvgIcon
                    v-visible="item.isActive"
                    name="icon-system-done"
                />
                <div class="dropdownItem_title">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import type { IDropdownGroup } from '@/interface/IDropdown';

    defineProps({
        itemGroups: {
            type: Object as PropType<IDropdownGroup[]>,
            required: true,
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/components/common/dropdown/DropdownMenu";
</style>
